"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const vue_property_decorator_1 = require("vue-property-decorator");
const order_1 = require("@/api/order");
let About = class About extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.isBottom = true;
        this.common = 0;
        this.middle = 0;
        this.high = 0;
    }
    goDiy(value) {
        sessionStorage.setItem('grade', value);
        this.$router.push('/diy');
    }
    getList() {
        let param = JSON.parse(sessionStorage.getItem('form'));
        order_1.getInstalledConfList(param).then(res => {
            res.common.forEach((item) => {
                this.common += item.actualPrice;
            });
            res.middle.forEach((item) => {
                this.middle += item.actualPrice;
            });
            res.high.forEach((item) => {
                this.high += item.actualPrice;
            });
        });
    }
    mounted() {
        //this.getList()
        // window.onscroll = ()=> {
        //           let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;//变量windowHeight是可视区的高度
        //           let documentScroll= window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;//文档滚动高度
        //           let top=this.$refs.cart.offsetTop;
        //         //变量scrollTop是滚动条滚动时，距离顶部的距离
        //         console.log(windowHeight+documentScroll-top-91)
        //           if(windowHeight+documentScroll-top-91<=-91){
        //             this.isBottom=false
        //           }
        // }
    }
};
About = __decorate([
    vue_property_decorator_1.Component({
        components: { HeaderTop: () => Promise.resolve().then(() => __importStar(require('@/components/HeaderTop/HeaderTop.vue'))), FooterBottom: () => Promise.resolve().then(() => __importStar(require('@/components/FooterBottom/Foot.vue'))) }
    })
], About);
exports.default = About;
